import { ReactElement, useMemo } from 'react';
import { Typography, Avatar } from '@mui/material';

import { toAbsoluteUrl } from '~utils/assetsHelpers';
import { getIntegrationProviderData } from '~utils/integrations';

import { useDashboardVariantV2GiverContext } from '../../../../Context';

import {
  DashboardVariantV2GiverActionsWidgetActionButton,
  DashboardVariantV2GiverActionsWidgetActionButtonImage,
  DashboardVariantV2GiverActionsWidgetActionAvatarGroup,
} from '../styles';

const DashboardVariantV2GiverActionsWidgetIntegrationsAction =
  (): ReactElement => {
    const {
      integrations: { data: integrations },
      dialogs: {
        integrations: { toggleOpen: toogleOpenDialogIntegrations },
      },
    } = useDashboardVariantV2GiverContext();

    const hasIntegrations = useMemo(
      () => integrations.length > 0,
      [integrations.length],
    );

    const label = useMemo(
      () => (!hasIntegrations ? 'CONECTA TUS TIENDAS' : 'TIENDAS CONECTADAS'),
      [hasIntegrations],
    );

    return (
      <DashboardVariantV2GiverActionsWidgetActionButton
        onClick={() => toogleOpenDialogIntegrations(true)}
      >
        <Typography variant="subtitle2" fontWeight="bold" width="60%">
          {label}
        </Typography>

        {!hasIntegrations && (
          <DashboardVariantV2GiverActionsWidgetActionButtonImage
            src={toAbsoluteUrl('/images/integrations_availables.png')}
            alt="Integrations Availables"
          />
        )}

        {hasIntegrations && (
          <DashboardVariantV2GiverActionsWidgetActionAvatarGroup max={2}>
            {integrations.map((integration) => {
              const integrationInfo = getIntegrationProviderData(
                integration.integrationTypeId,
              );

              return (
                <Avatar
                  key={`integration-avatar-user-${integration.companyIntegrationId}`}
                  alt={integrationInfo?.logoSmall.alt}
                  src={integrationInfo?.logoSmall.url}
                />
              );
            })}
          </DashboardVariantV2GiverActionsWidgetActionAvatarGroup>
        )}
      </DashboardVariantV2GiverActionsWidgetActionButton>
    );
  };

export default DashboardVariantV2GiverActionsWidgetIntegrationsAction;
